import type { ExternalTableSchema } from '@packages/table-builder';

export const brokerSsoKeyManagementTable: ExternalTableSchema = {
  metadata: {
    title: 'Key Management',
    entity: 'BrokerSsoKeyManagement',
  },

  dataSource: {
    endpoint:
      '/api/identity/api/app/broker-sso-configuration-key/by-configuration-id/{BrokerSsoConfigurationId}',
    method: 'GET',
    rowIdField: 'id',
    pathParams: { BrokerSsoConfigurationId: 'brokerSsoConfigurationId' },
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    {
      field: 'creationTime',
      header: 'Created Date',
      type: 'date',
      width: 200,
      sortable: false,
    },
    {
      field: 'lastModificationTime',
      header: 'Modifiication Date',
      type: 'date',
      width: 200,
      sortable: false,
    },
    {
      field: 'effectiveFrom',
      header: 'Effective Date',
      type: 'date',
      width: 200,
      sortable: false,
    },
    {
      field: 'expiresAt',
      header: 'Expiration Date',
      type: 'date',
      width: 200,
      sortable: false,
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_BROKER_SSO_KEY', label: 'View Keys' },
      { id: 'EDIT_BROKER_SSO_KEY', label: 'Edit' },
      { id: 'DELETE_BROKER_SSO_KEY', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_BROKER_SSO_KEY',
        label: 'Add Key',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'pagination', defaultSize: 10 },
    columnPreferences: {
      persistenceKey: 'Key Management',
      reorderable: true,
      resizable: true,
    },
  },
};

export function withBrokerSsoConfigurationIdEndpoint(
  schema: ExternalTableSchema,
  brokerSsoConfigurationId: string,
): ExternalTableSchema {
  return {
    ...schema,
    dataSource: schema.dataSource
      ? {
          ...schema.dataSource,
          endpoint: schema.dataSource.endpoint.replace(
            '{BrokerSsoConfigurationId}',
            brokerSsoConfigurationId,
          ),
          pathParams: {},
        }
      : schema.dataSource,
  };
}
